import dom, { Fragment } from "../../../../dist/jsx-render/dom";
import { BaseControl } from "../BaseControl";
import { DynamicController } from "../DynamicController";
import { MatrixObject } from "../../../Areas/Admin/Measures/TemplateEdit/Matrix/MatrixObject";
import { app } from "../../../Frame/App";
import { MatrixCell } from "../../../Areas/Admin/Measures/TemplateEdit/Matrix/MatrixCell";
import { MatrixRow } from "../../../Areas/Admin/Measures/TemplateEdit/Matrix/MatrixRow";
import { FullscreenDisplay } from "./Modules/FullscreenDisplay";
import { DateControl } from "../DateControl";
import { IIterationControl } from "../IIterationControl";
import { DecimalDto } from "../../../Model/DecimalDto";
import { LanguageString } from "../../../Model/LanguageString";

export enum CopyRowCommand { before, after }
export class MatrixControl extends BaseControl {
    container: HTMLElement;
    controls: BaseControl[] = [];

    fixedRows: number;
    fixedColumns: number;
    hasIteration: boolean;
    hasMultiRowInTable: boolean;

    multiRowMatrixObject: MatrixObject;


    constructor(controller: DynamicController, private matrixObject: MatrixObject, measureId?: number, private fullscreenDisplay?: FullscreenDisplay) {
        super(matrixObject.containerElement, controller, measureId);
        this.container = matrixObject.containerElement;

        this.createTable();
        if (this.fullscreenDisplay) {
            let hoverElement = this.container.querySelector(".matrix-tables") as HTMLElement;
            this.fullscreenDisplay.createFullscreenButton(hoverElement, this.container);
        }
    }

    createTable = () => {
        if ((this.matrixObject.fixedColumns && this.matrixObject.fixedColumns > 0)
            || (this.matrixObject.fixedRows && this.matrixObject.fixedRows > 0)) {
            this.createComplexTable();
        } else {
            this.createSimpleTable();
        }
    }

    private createSimpleTable = () => {
        let element: HTMLDivElement = <div class="matrix-tables matrix-scroll"></div>;
        let tableElement: HTMLElement = <table></table>;
        element.appendChild(tableElement);

        this.hasMultiRowInTable = this.matrixObject.multiRow && this.matrixObject.multiRowValue > -1 && this.matrixObject.multiRowValue <= this.matrixObject.rows.length;
        this.hasIteration = this.matrixObject.iterationDateFieldId && this.matrixObject.iterationFirstColumn && this.matrixObject.iterationNumberOfColumns ? true : false;

        // matrix with iterations?
        if (this.hasIteration) {
            this.createMatrixWithIteration(tableElement);
        }
        // matrix with multirows
        else if (this.hasMultiRowInTable) {
            this.createMatrixWithMultiRows(tableElement);
        }
        else {
            for (let row of this.matrixObject.rows) {
                let rowElement: HTMLTableRowElement = <tr></tr>;
                for (let cell of row.cells) {
                    if (!cell.isHidden()) {
                        this.createCell(cell, rowElement);
                    }
                }
                tableElement.appendChild(rowElement);
            }
        }

        this.container.appendChild(element);
    }

    private createMatrixWithIteration = (tableElement: HTMLElement) => {//last column for interation
        const iterationLastColumn = this.matrixObject.iterationFirstColumn + this.matrixObject.iterationNumberOfColumns - 1;
        // get iteration start index
        let isValidIteration = true;
        let firstIterationValue: number;
        let iterationCount: number = 0;
        if (!this.matrixObject.useInWidget) {
            const dateControl = this.controller.getControl(this.matrixObject.iterationDateFieldId) as DateControl;
            if (dateControl) {
                let dateValue = app.anyToDate(dateControl.getValue(0));
                if (dateValue) {
                    if (this.matrixObject.intervalType == 1) {
                        // monthly
                        firstIterationValue = dateValue.getFullYear() * 12;
                        firstIterationValue += dateValue.getMonth();
                    }
                    else {
                        // yearly
                        firstIterationValue = dateValue.getFullYear();
                    }
                    if (this.matrixObject.iterationOffset) {
                        firstIterationValue += this.matrixObject.iterationOffset;
                    }
                }
                else {
                    tableElement.appendChild(<td style={{ color: "red" }}>{"missing date value"}</td>);
                    isValidIteration = false;
                }
            }
            else {
                tableElement.appendChild(<td style={{ color: "red" }}>{`Unknown date control: ${this.matrixObject.iterationDateFieldId}`}</td>);
                isValidIteration = false;
            }

            if (this.matrixObject.iterationType && this.matrixObject.iterationType == 1) {
                let endDateControl = this.controller.getControl(this.matrixObject.iterationEndDateFieldId) as DateControl;
                if (endDateControl) {
                    let endDateValue = app.anyToDate(endDateControl.getValue(0));
                    if (endDateValue) {
                        if (this.matrixObject.intervalType == 1) {
                            // monthly
                            let lastIterationValue = endDateValue.getFullYear() * 12;
                            lastIterationValue += endDateValue.getMonth();

                            if (this.matrixObject.iterationEndDateOffset) {
                                lastIterationValue += this.matrixObject.iterationEndDateOffset;
                            }

                            if (firstIterationValue !== null && lastIterationValue !== null) {
                                iterationCount = lastIterationValue - firstIterationValue + 1;
                            }
                        }
                        else {
                            // yearly
                            let lastIterationValue = endDateValue.getFullYear();
                            if (this.matrixObject.iterationEndDateOffset) {
                                lastIterationValue += this.matrixObject.iterationEndDateOffset;
                            }

                            if (firstIterationValue !== null && lastIterationValue !== null) {
                                iterationCount = lastIterationValue - firstIterationValue + 1;
                            }
                        }
                    }
                    else {
                        tableElement.appendChild(<td style={{ color: "red" }}>{"missing end date value"}</td>);
                        isValidIteration = false;
                    }
                }
                else {
                    tableElement.appendChild(<td style={{ color: "red" }}>{`Unknown date control: ${this.matrixObject.iterationEndDateFieldId}`}</td>);
                    isValidIteration = false;
                }
            }
            else {
                iterationCount = this.matrixObject.iterationCount;
            }

        } else {
            if (this.matrixObject.widgetModel.widgetIterationDate) {
                let dateValue = app.anyToDate(this.matrixObject.widgetModel.widgetIterationDate);
                if (dateValue) {
                    if (this.matrixObject.intervalType == 1) {
                        // monthly
                        firstIterationValue = dateValue.getFullYear() * 12;
                        firstIterationValue += dateValue.getMonth();
                    }
                    else {
                        // yearly
                        firstIterationValue = dateValue.getFullYear();
                    }
                    if (this.matrixObject.iterationOffset) {
                        firstIterationValue += this.matrixObject.iterationOffset;
                    }
                }
            }

            iterationCount = this.matrixObject.iterationCount;
        }



        if (isValidIteration) {
            // create all rows
            for (let row of this.matrixObject.rows) {
                let rowElement: HTMLTableRowElement = <tr></tr>;

                // create all cells before iteration part
                let index = 1;
                for (let cell of row.cells) {
                    if (index < this.matrixObject.iterationFirstColumn) {
                        if (!cell.isHidden()) {
                            this.createCell(cell, rowElement);
                        }
                    }
                    else {
                        break;
                    }
                    index++;
                }

                // create iteration cells
                for (let iterationIndex = 0; iterationIndex < iterationCount; iterationIndex++) {
                    index = 1;
                    for (let cell of row.cells) {
                        if (index >= this.matrixObject.iterationFirstColumn && index <= iterationLastColumn) {
                            if (!cell.isHidden()) {
                                this.createCell(cell, rowElement, firstIterationValue + iterationIndex, iterationIndex);
                            }
                        }
                        index++;
                    }
                }

                // create all cells after iteration part
                index = 1;
                for (let cell of row.cells) {
                    if (index > iterationLastColumn) {
                        if (!cell.isHidden()) {
                            this.createCell(cell, rowElement);
                        }
                    }
                    index++;
                }

                tableElement.appendChild(rowElement);
            }
        }
    }

    private createMatrixWithMultiRows = (tableElement: HTMLElement) => {
        // create another matrix object for new structure of rows
        this.multiRowMatrixObject = new MatrixObject(this.matrixObject.fields);
        this.multiRowMatrixObject.rows = [];
        let newIndex = 0;
        for (let row of this.matrixObject.rows) {
            if (row.rowIndex != (this.matrixObject.multiRowValue - 1)) {
                row.rowIndex = newIndex;
                this.multiRowMatrixObject.rows.push(row);
            } else {
                if (this.matrixObject.additionalMultiRows != null && this.matrixObject.additionalMultiRows.length > 0) {
                    let matrixMultiRow = this.matrixObject.rows[this.matrixObject.multiRowValue - 1];
                    // create multirows
                    let items = this.matrixObject.additionalMultiRows;
                    for (var j = 0; j < items.length; j++) {
                        // create new MatrixRow
                        var newRow = new MatrixRow(this.matrixObject, newIndex);
                        newRow.isMultiRowItem = true;
                        newRow.multiRowItemValue = items[j];

                        // create all row cells
                        for (var i = 0; i < matrixMultiRow.cells.length; i++) {
                            var cell = matrixMultiRow.cells[i];
                            var newCell = new MatrixCell(cell.type, newRow);
                            newCell.rowSpan = 1;
                            newCell.colSpan = cell.colSpan;
                            newCell.width = cell.width;
                            newCell.value = cell.value;
                            newRow.cells.push(newCell);
                        }

                        if (items[j] == items[items.length - 1])
                            newRow.hasMultiRowDeleteCommand = false;

                        this.multiRowMatrixObject.rows.push(newRow);

                        if (items[j] < items[items.length - 1])
                            newIndex++;
                    }
                } else {
                    row.rowIndex = newIndex;
                    row.isMultiRowItem = true;
                    this.multiRowMatrixObject.rows.push(row);
                }
            }
            newIndex++;
        }

        // create the matrix table from the new matrix object
        let index = 1;
        let mrIndex = 1;
        for (let row of this.multiRowMatrixObject.rows) {
            let rowElement: HTMLTableRowElement = <tr className="matrix-row mrc" data-rowindex={index}></tr>;
            let isdisabled: boolean = false;
            for (let cell of row.cells) {
                let control = this.matrixObject.dynamicElements.find(c => c.getAttribute("data-field") == cell.value)
                if (!cell.isHidden()) {
                    if (row.isMultiRowItem) {
                        isdisabled = control?.getAttribute("disabled") == "disabled";
                        this.createCell(cell, rowElement, null, null, row.multiRowItemValue);
                    }
                    else
                        this.createCell(cell, rowElement);
                }
            }

            if (row.isMultiRowItem && !this.matrixObject.useInWidget) {
                rowElement.setAttribute("data-multirow", mrIndex.toString());
                mrIndex++;
                rowElement.appendChild(this.appendMultiRowButtonsCellElement(row, tableElement, rowElement, isdisabled));
            }
            tableElement.appendChild(rowElement);
            index++;
        }
    }

    private createComplexTable = () => {
        let id = this.container.getAttribute("data-field-id");
        let element = <div className="matrix-tables" data-id={id}>

            <div className="matrix-fixed-left">

                <div className="matrix-header" id={"mc_leftmatrixheader_" + id}>
                    <table className="matrixContentTable matrixFixedLeftTable" cellpadding="0" cellspacing="0">
                        <tbody />
                    </table>
                </div>

                <div className="matrix-rows" id={"mc_leftmatrixrows_" + id}>
                    <table class="matrixContentTable" cellpadding="0" cellspacing="0">
                        <tbody />
                    </table>
                </div>
            </div>

            <div className="matrix-right">
                <div className="matrix-header" id={"mc_rightmatrixheader_" + id}>
                    <table class="matrixContentTable matrixHeaderTable" cellpadding="0" cellspacing="0">
                        <tbody />
                    </table>
                </div>

                <div className="matrix-rows" id={"mc_rightmatrixrows_" + id}>
                    <table class="matrixContentTable" cellpadding="0" cellspacing="0">
                        <tbody />
                    </table>
                </div>
            </div>

        </div>;

        let tableHeaderLeft = element.querySelector(".matrix-fixed-left .matrix-header .matrixFixedLeftTable tbody") as HTMLTableElement;
        let tableLeft = element.querySelector(".matrix-fixed-left .matrix-rows .matrixContentTable tbody") as HTMLTableElement;

        let tableHeader = element.querySelector(".matrix-right .matrix-header tbody") as HTMLTableElement;
        let tableContent = element.querySelector(".matrix-right .matrix-rows .matrixContentTable tbody") as HTMLTableElement;

        this.fixedRows = this.matrixObject.fixedRows ?? 0;
        this.fixedColumns = this.matrixObject.fixedColumns ?? 0;

        for (let row of this.matrixObject.rows) {
            if (this.fixedRows > 0 && this.matrixObject.rows.indexOf(row) < this.fixedRows) {
                let headerLeftRow: HTMLTableRowElement;
                let headerRow: HTMLTableRowElement;

                if (this.fixedColumns > 0) {
                    headerLeftRow = <tr />;
                    tableHeaderLeft.appendChild(headerLeftRow);
                }
                headerRow = <tr />;
                tableHeader.appendChild(headerRow);

                this.createCellInComplexTables(row, headerLeftRow, headerRow);

            } else {
                let tableLeftRow: HTMLTableRowElement;
                let tableContentRow: HTMLTableRowElement;

                if (this.fixedColumns > 0) {
                    tableLeftRow = <tr />;
                    tableLeft.appendChild(tableLeftRow);
                }
                tableContentRow = <tr />;
                tableContent.appendChild(tableContentRow);

                this.createCellInComplexTables(row, tableLeftRow, tableContentRow);
            }
        }

        if (this.fixedRows == 0) {
            this.container.querySelectorAll(".matrix-header").forEach(h => app.destroyDomElements(h as HTMLElement));
        }

        this.container.appendChild(element);

        // Adjust row heights
        this.adjustRowHeights(tableHeaderLeft,
            tableHeader,
            tableLeft,
            tableContent);

        this.container.parentElement.classList.add("overflow-x-auto");
    }

    private adjustRowHeights = (
        tableHeaderLeft: HTMLTableElement,
        tableHeader: HTMLTableElement,
        tableLeft: HTMLTableElement,
        tableContent: HTMLTableElement) => {
        for (let i: number = 0; i < this.fixedRows; i++) {
            let leftRow = tableHeaderLeft.rows[i] as HTMLTableRowElement;
            let rightRow = tableHeader.rows[i] as HTMLTableRowElement;

            this.compareRowsSetHeight(leftRow, rightRow);
        }

        for (let i: number = 0; i < this.matrixObject.rows.length - this.fixedRows; i++) {
            let leftRow = tableLeft.rows[i] as HTMLTableRowElement;
            let rightRow = tableContent.rows[i] as HTMLTableRowElement;

            this.compareRowsSetHeight(leftRow, rightRow);
        }
    }

    private compareRowsSetHeight = (leftRow: HTMLTableRowElement, rightRow: HTMLTableRowElement) => {
        if (leftRow && rightRow) {
            // Set styles for both rows to assure they share the same height. Otherwise, there might be issues with rowspan.

            if (leftRow.clientHeight > rightRow.clientHeight) {
                let height = leftRow.clientHeight + "px";

                rightRow.style.height = height;
                rightRow.style.minHeight = height;
                leftRow.style.height = height;
                leftRow.style.minHeight = height;
            } else if (leftRow.clientHeight < rightRow.clientHeight) {
                let height = rightRow.clientHeight + "px";

                leftRow.style.height = height;
                leftRow.style.minHeight = height;
                rightRow.style.height = height;
                rightRow.style.minHeight = height;
            }
        }
    }

    private createCellInComplexTables = (row: MatrixRow, leftRow: HTMLTableRowElement, rightRow: HTMLTableRowElement) => {

        for (let cell of row.cells) {
            if (!cell.isHidden()) {
                if (this.fixedColumns && row.cells.indexOf(cell) < this.fixedColumns) {
                    this.createCell(cell, leftRow);
                } else {
                    this.createCell(cell, rightRow);
                }
            }
        }
    }

    private createCell = (cell: MatrixCell, rowElement: HTMLTableRowElement, iterationValue: number = 0, iterationIndex: number = 0, multirowValue: number = null) => {
        let cellElement: HTMLTableCellElement = <td className="matrix-cell"></td>;

        if (cell.width) {
            cellElement.width = cell.width + "px";
            cellElement.style.minWidth = cell.width + "px";
        }

        cellElement.rowSpan = cell.rowSpan;
        cellElement.colSpan = cell.colSpan;

        switch (cell.type) {
            case "t":
                if (iterationValue != 0 && cell.value && cell.value == "#ITERATION#") {
                    if (this.matrixObject.intervalType == 1) {
                        // monthly
                        const month = (iterationValue % 12) + 1;
                        const year = Math.floor(iterationValue / 12);
                        cellElement.innerText = month >= 10 ? `${month}/${year}` : `0${month}/${year}`;
                    }
                    else {
                        // yearly
                        cellElement.innerText = iterationValue.toString();
                    }
                }
                else {
                    if (cell.value && cell.value.startsWith("{") && this.cellIsMultiLanguage(cell)) {
                        try {
                            let deserializedObject = JSON.parse(cell.value);
                            let languageString = LanguageString.fromPartial(deserializedObject as LanguageString);
                            cellElement.innerText = languageString.inLanguage;
                        } catch (err) {
                            console.log(err);
                            cellElement.innerText = cell.value;
                        }
                    }
                    else if (cell.value && cell.value.startsWith("{") && cell.value.indexOf("decimalSeperator") > -1) {
                        try {
                            let dto = JSON.parse(cell.value) as DecimalDto;
                            cellElement.innerText = app.formatDecimalNumber(dto.fieldValue, dto.decimalSeperator, dto.decimalPlaces);
                        } catch (err) {
                            console.log(err);
                            cellElement.innerText = cell.value;
                        }
                    }
                    else {
                        if (cell.value && cell.value.startsWith("#b#")) {
                            cellElement.innerText = cell.value.substr(3);
                            cellElement.classList.add("font-weight-bold");

                        }
                        else {
                            cellElement.innerText = cell.value;
                        }
                    }
                }
                cellElement.classList.add("text-cell");
                break;
            case "f":
                if (!this.matrixObject.useInWidget) {
                    this.createFieldCell(cell, cellElement, iterationValue, iterationIndex, multirowValue);
                } else {
                    this.createWidgetFieldCell(cell, cellElement, iterationValue, iterationIndex, multirowValue);
                    cellElement.classList.add("feld-cell");
                }
                break;
            case "n":
                this.createFieldNameCell(cell, cellElement);
                break;
            default:
                break;
        }
        rowElement.appendChild(cellElement);
    }

    private createFieldCell = (cell: MatrixCell, cellElement: HTMLTableCellElement, iterationValue: number, iterationIndex: number, multirowValue?: number) => {
        let control: HTMLElement;

        // iteration field?
        if (iterationValue) {
            control = this.matrixObject.dynamicElements.find(c => c.getAttribute("data-field") == cell.value);
            if (control) {
                let fieldId = parseInt(control.getAttribute("data-field-id"));
                let dynControl = this.controller.getControl(fieldId);
                if (!dynControl) {
                    dynControl = this.controller.getControlForType(control);
                }
                if (dynControl && dynControl.isIteration) {
                    // mark required field
                    //if (control.getAttribute("data-required") == "true") {
                    //    cellElement.classList.add("dyn-required-cell");
                    //}

                    // disabled matrix?
                    if (this.matrixObject.isReadonly) {
                        if ((control as HTMLInputElement).readOnly !== undefined) {
                            (control as HTMLInputElement).readOnly = true;
                        }
                        else if ((control as HTMLSelectElement).disabled !== undefined) {
                            (control as HTMLSelectElement).disabled = true;
                        }
                    }

                    // remove existing control block
                    let controlParent = control.closest(".dyn-control-frame") as HTMLElement;
                    if (controlParent) {
                        cellElement.appendChild(control);
                        app.destroyDomElements(controlParent);
                    }

                    // add control to our list
                    this.controls.push(dynControl);

                    // creat input control
                    cellElement.appendChild(((dynControl as any) as IIterationControl).createIterationControl(iterationValue));

                    // we are done
                    return;
                }
            }
        }

        if (multirowValue != null) {
            control = this.matrixObject.dynamicElements.find(c => c.getAttribute("data-field") == cell.value);
            if (control) {
                let fieldId = parseInt(control.getAttribute("data-field-id"));
                let dynControl = this.controller.getControl(fieldId);
                if (!dynControl) {
                    dynControl = this.controller.getControlForType(control);
                }
                if (dynControl) {
                    // mark required field
                    //if (control.getAttribute("data-required") == "true") {
                    //    cellElement.classList.add("dyn-required-cell");
                    //}

                    // disabled matrix?
                    if (this.matrixObject.isReadonly) {
                        if ((control as HTMLInputElement).readOnly !== undefined) {
                            (control as HTMLInputElement).readOnly = true;
                        }
                        else if ((control as HTMLSelectElement).disabled !== undefined) {
                            (control as HTMLSelectElement).disabled = true;
                        }
                    }

                    // remove existing control block
                    let controlParent = control.closest(".dyn-control-frame") as HTMLElement;
                    if (controlParent && !controlParent.classList.contains("dyn-type-matrix")) {
                        cellElement.appendChild(control);
                        app.destroyDomElements(controlParent);
                    }

                    // add control to our list
                    if (this.controls.indexOf(dynControl) == -1)
                        this.controls.push(dynControl);

                    // creat input control
                    cellElement.appendChild(((dynControl as any) as IIterationControl).createIterationControl(multirowValue));

                    // we are done
                    return;
                }
            }
        }

        if (cell.value != null && cell.value.startsWith("CAT#")) {
            let categoryId = cell.value.replace("CAT#", "");
            control = this.matrixObject.dynamicElements.find(c => c.getAttribute("data-category-id") == categoryId);
        }
        else {
            control = this.matrixObject.dynamicElements.find(c => c.getAttribute("data-field") == cell.value);
        }

        if (control) {
            this.createControl(control, cell, cellElement);
        }
    }

    private createControl = (control: HTMLElement, cell: MatrixCell, cellElement: HTMLTableCellElement, iterationValue: number = 0) => {

        //if (control.getAttribute("data-required") == "true") {
        //    cellElement.classList.add("dyn-required-cell");
        //}

        if (this.matrixObject.isReadonly) {
            if ((control as HTMLInputElement).readOnly !== undefined) {
                (control as HTMLInputElement).readOnly = true;
            }
            else if ((control as HTMLSelectElement).disabled !== undefined) {
                (control as HTMLSelectElement).disabled = true;
            }
        }
        // Buffer parent controls to remove Label (and other elements a standalone control has) from the dom. 
        // The field is only displayed in the Matrix.
        let controlParent = control.closest(".dyn-control-frame") as HTMLElement;

        if (!controlParent) {
            console.log("Ein Feld ist möglicherweise doppelt in einer Matrix vorhanden:" + cell.value);
            console.log(control);
        }
        else {
            // Append control to current cell
            if (control.classList.contains("dyn-control-user")
                || control.classList.contains("dyn-control-category")
                || control.classList.contains("dyn-control-multiline")
                || control.classList.contains("dyn-control-text")
                || control.classList.contains("dyn-control-date")
                || control.classList.contains("dyn-control-richtext")
                || control.classList.contains("dyn-control-double")
            ) {
                cellElement.appendChild(control.parentElement);
            }
            else {
                cellElement.appendChild(control);
            }

            // Remove other elements after the control was put in the matrix table.
            try {
                app.destroyDomElements(controlParent);
            }
            catch (err) {
                console.log(err);
                console.log(control);
            }

            // Create control
            let dynControl = this.controller.getControlForType(control)
            this.controls.push(dynControl);
        }
    }

    private appendMultiRowButtonsCellElement = (row: MatrixRow, tableElement: HTMLElement, rowElement?: HTMLTableRowElement, isdisabled?: boolean): HTMLTableCellElement => {

        let cellElement: HTMLTableCellElement = <td className="matrix-cell command-cell"></td>;
        cellElement.width = "80px";
        cellElement.style.minWidth = "80px";
        cellElement.rowSpan = 1;
        cellElement.colSpan = 1;

        if (isdisabled)
            return cellElement;

        let multiRowButtonElement: HTMLElement = <div className="button-cell d-flex justify-content-around">
            <img id="matrixImageRowBefore" class="pointer" src={app.resolveUrl("~/images/matrix_add_row_above.png")} title={"matrixImageRowBefore"} />
            <img id="matrixImageRowAfter" class="pointer" src={app.resolveUrl("~/images/matrix_add_row_below.png")} title={"matrixImageRowAfter"} />
            <img id="matrixImageRowDelete" class="pointer" src={app.resolveUrl("~/images/matrix_delete_row.png")} title="matrixImageRowDelete" />
        </div>

        cellElement.appendChild(multiRowButtonElement);


        multiRowButtonElement.querySelector("#matrixImageRowBefore").addEventListener("click", (ev: MouseEvent) => {
            this.copyMultiRow(row, tableElement, CopyRowCommand.before, rowElement);
        });
        multiRowButtonElement.querySelector("#matrixImageRowAfter").addEventListener("click", (ev: MouseEvent) => {
            this.copyMultiRow(row, tableElement, CopyRowCommand.after, rowElement);
        });
        multiRowButtonElement.querySelector("#matrixImageRowDelete").addEventListener("click", (ev: MouseEvent) => {
            this.deleteMultiRow(row, rowElement, tableElement);
        });

        // show/ hide delete button depending on the row prop: hasMultiRowDeleteCommand
        // always the last multirow does not have the delete btn, to keep et least one multirow
        if (row.isMultiRowItem) {
            if (!row.hasMultiRowDeleteCommand)
                multiRowButtonElement.querySelector("#matrixImageRowDelete").classList.add("d-none");
            else
                multiRowButtonElement.querySelector("#matrixImageRowDelete").classList.remove("d-none");
        }

        return cellElement;
    }

    private copyMultiRow = (fromRow: MatrixRow, tableElement: HTMLElement, command: CopyRowCommand, rowElement: HTMLTableRowElement) => {
        try {
            let newrowElement: HTMLTableRowElement = <tr className="matrix-row mrc"></tr>;

            let tempRowIndex: number;
            let tempMRIndex: number;

            let currentRowIndex = parseInt(rowElement.getAttribute("data-rowindex"));
            let currentMultiRowIndex = parseInt(rowElement.getAttribute("data-multirow"));

            if (command == CopyRowCommand.before) {

                tempRowIndex = currentRowIndex;
                tempMRIndex = currentMultiRowIndex;
            }
            else {
                tempRowIndex = currentRowIndex + 1;
                tempMRIndex = currentMultiRowIndex + 1;
            }

            // update multirows index of inputs (data-multirow attribute) in matrix element
            tableElement.querySelectorAll("input.multirow-control").forEach(e => {
                if (e?.hasAttribute("data-multirow") && parseInt(e?.getAttribute("data-multirow")) >= tempMRIndex) {
                    let datamultirow = parseInt(e?.getAttribute("data-multirow")) + 1;
                    (e as HTMLInputElement)?.setAttribute("data-multirow", datamultirow.toString());
                }
            });
            tableElement.querySelectorAll("textarea.multirow-control").forEach(e => {
                if (e?.hasAttribute("data-multirow") && parseInt(e?.getAttribute("data-multirow")) >= tempMRIndex) {
                    let datamultirow = parseInt(e?.getAttribute("data-multirow")) + 1;
                    (e as HTMLTextAreaElement)?.setAttribute("data-multirow", datamultirow.toString());
                }
            });

            // update rows index (data-rowindex attribute) in matrix element
            tableElement.querySelectorAll(".matrix-row.mrc").forEach(e => {
                // update row index
                if (e?.hasAttribute("data-rowindex") && parseInt(e?.getAttribute("data-rowindex")) >= tempRowIndex) {
                    let dataRowIndex = parseInt(e?.getAttribute("data-rowindex")) + 1;
                    (e as HTMLInputElement)?.setAttribute("data-rowindex", dataRowIndex.toString());
                }
                // update multirow index
                if (e?.hasAttribute("data-multirow") && parseInt(e?.getAttribute("data-multirow")) >= tempMRIndex) {
                    let dataRowIndex = parseInt(e?.getAttribute("data-multirow")) + 1;
                    (e as HTMLInputElement)?.setAttribute("data-multirow", dataRowIndex.toString());
                }
            });

            // update rows index in matrix object
            this.multiRowMatrixObject.rows.sort().filter(f => f.rowIndex >= tempRowIndex).forEach(e => e.rowIndex++);

            var newRow = new MatrixRow(this.multiRowMatrixObject, tempRowIndex);
            newRow.isMultiRowItem = true
            newRow.hasMultiRowDeleteCommand = true;
            newRow.cells = fromRow.cells;


            newrowElement.setAttribute("data-rowindex", newRow.rowIndex.toString());
            newrowElement.setAttribute("data-multirow", tempMRIndex.toString());

            for (let cell of newRow.cells) {
                if (!cell.isHidden()) {
                    this.createCell(cell, newrowElement, null, null, tempMRIndex);
                }
            }
            this.multiRowMatrixObject.rows.push(newRow);

            // additional cell for insert commands
            newrowElement.appendChild(this.appendMultiRowButtonsCellElement(newRow, tableElement, newrowElement));

            // append new row 
            if (command == CopyRowCommand.before)
                tableElement.insertBefore(newrowElement, rowElement);
            else
                rowElement.after(newrowElement);

        }
        catch (err) {
            alert("MatrixCommand.insertRow(" + command + ") :" + + err.message);
        }
    }

    private deleteMultiRow = (rowToDelete: MatrixRow, rowElement: HTMLTableRowElement, tableElement: HTMLElement) => {
        let rowToDeleteIndex: number = rowToDelete.rowIndex;

        // update rows index (data-multirow attribute) in matrix element
        tableElement.querySelectorAll("input.multirow-control").forEach(e => {
            if (e?.hasAttribute("data-multirow") && parseInt(e?.getAttribute("data-multirow")) > rowToDeleteIndex) {
                let datamultirow = parseInt(e?.getAttribute("data-multirow")) - 1;
                (e as HTMLInputElement)?.setAttribute("data-multirow", datamultirow.toString());
            }
        });

        // set default index to deleted row to not be considerated later in binding data to server
        if (this.multiRowMatrixObject.rows.find(r => r.rowIndex == rowToDeleteIndex)) {
            this.multiRowMatrixObject.rows.find(r => r.rowIndex == rowToDeleteIndex).rowIndex = -1;
        }
        /* this.multiRowMatrixObject.rows[rowToDeleteIndex].rowIndex = -1;*/

        // update rows index in matrix object
        this.multiRowMatrixObject.rows.sort().filter(f => f.rowIndex > rowToDeleteIndex).forEach(e => e.rowIndex--);

        // hide row from table
        (rowElement.querySelector("input.multirow-control") as HTMLInputElement).setAttribute("data-multirow", "-1");
        rowElement.classList.add("d-none");
    }

    private createFieldNameCell = (cell: MatrixCell, cellElement: HTMLTableCellElement) => {
        cellElement.innerText = this.matrixObject.fieldNames[cell.value] ?? "";
    }

    private createWidgetFieldCell = (cell: MatrixCell, cellElement: HTMLTableCellElement, iterationValue: number, iterationIndex: number, multirowValue?: number) => {

        if (iterationValue || multirowValue) {
            let value: { [field: number]: any } = JSON.parse(this.matrixObject.widgetModel.widgetFields[cell.value]);
            if (iterationValue) {
                try {
                    var zahl = parseInt(value[iterationValue]);
                    if (!isNaN(zahl)) {
                        cellElement.innerText = value[iterationValue] ?? "";

                        cellElement.classList.add("text-right");
                    } else {
                        let dto = value[iterationValue] as DecimalDto;
                        cellElement.innerText = app.formatDecimalNumber(dto.fieldValue, dto.decimalSeperator, dto.decimalPlaces);
                    }
                } catch { }
            }
            else {
                cellElement.innerText = value[multirowValue] ?? "";
                try {
                    var zahl = parseInt(value[multirowValue]);
                    if (!isNaN(zahl)) {
                        cellElement.classList.add("text-right");
                    }
                } catch { }
            }


            return;
        }

        if (multirowValue) {
            return;
        }
        cellElement.innerText = this.matrixObject.widgetModel.widgetFields[cell.value] ?? "";
        try {
            var zahl = parseInt(this.matrixObject.widgetModel.widgetFields[cell.value]);
            if (!isNaN(zahl)) {
                cellElement.classList.add("text-right");
            }
        } catch { }

    }

    private cellIsMultiLanguage(cell: MatrixCell) {
        return cell.value.indexOf("valueCs") > -1
            || cell.value.indexOf("valueDe") > -1
            || cell.value.indexOf("valueEn") > -1
            || cell.value.indexOf("valueFr") > -1
            || cell.value.indexOf("valueKo") > -1
            || cell.value.indexOf("valueRu") > -1
            || cell.value.indexOf("valueSv") > -1;
    }

    public isEmpty(): boolean {
        for (let control of this.controls) {
            if (control.isEmpty()) return true;
        }
        return false;
    }

    public getValue() {
        throw new Error("Method not implemented.");
    }
}